import { render, staticRenderFns } from "./LatestPublicationsPage.vue?vue&type=template&id=22668d83"
import script from "./LatestPublicationsPage.vue?vue&type=script&lang=js"
export * from "./LatestPublicationsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports